export enum DispersionMode {
    Carry = "Carry",
    Total = "Total",
    NotDefined = "",
    c = Carry,
    t = Total
}

export function GetDispersionMode(s: string) : DispersionMode {
    switch(s.toLowerCase()){
        case "carry":
            return DispersionMode.Carry;
        case "total":
            return DispersionMode.Total;
        case "notdefined":
            return DispersionMode.NotDefined;
        case "c":                
            return DispersionMode.Carry;
        case "t":
            return DispersionMode.Total;
        default:
            return DispersionMode.NotDefined;
    }
}